import type { OnInit } from '@angular/core'
import { Component, inject } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'

@Component({
  selector: 'dhp-old-magazine',
  template: ` <p>Redirecting...</p> `,
})
export class OldMagazineComponent implements OnInit {
  private route = inject(ActivatedRoute)
  private router = inject(Router)

  ngOnInit(): void {
    const magazineId = this.route.snapshot.data['magazineId']

    if (magazineId) {
      this.router.navigate(['/magazines/detail', magazineId], {
        queryParams: { banner: 'oldsite' },
      })
    } else {
      console.error('No magazine ID found in route data.')
    }
  }
}
